import type { CommonData } from '@/components/blockEditor/blockEditor.types';
import { CURRENT_SCHEMA_VERSION } from '@/components/blockEditor/blockEditor.types';

export function getDefaultDraftData(): CommonData {
  return {
    version: CURRENT_SCHEMA_VERSION,
    blocks: [
      {
        id: 'root',
        type: 'ListItemsSection',
        props: {},
        children: {
          default: [
            {
              id: 'draft-columns',
              type: 'TwoColumnLayout',
              props: {
                leftWidth: '50%',
                rightWidth: '50%',
                columnGap: 5,
                showDivider: true,
              },
              children: {
                leftColumn: [],
                rightColumn: [],
              },
            },
          ],
        },
      },
    ],
  };
}
